export default "__VITE_ASSET__ff62efd0__"